import React, { Fragment } from 'react';
import isNil from 'lodash/isNil';
import useCandidate from '../../app/components/useCandidate';
import { HireRejectConfirmationModal } from '../messaging/seeker/header/actionsDropdown/HireRejectConfirmationModal';
import { useStoreActions, useStoreState } from '../../models/hooks';

export type SendHRformModalProps = {
  isOpen: boolean;
  onClose: () => void;
  currentCandidateId: string;
  currentTask?: string;
  currentDocId?: string;
};

export const SendHRformModal = ({
  isOpen,
  onClose,
  currentCandidateId,
  currentDocId,
  currentTask,
}: SendHRformModalProps): JSX.Element => {
  const currentCandidate = useCandidate(currentCandidateId);
  const userId = useStoreState((states) => states.app.user?.id);
  const { updateRecruiterActionStatus } = useStoreActions((actions) => actions.toDoList);

  const updateToCompleted = async () => {
    if (currentDocId && userId && currentTask) {
      await updateRecruiterActionStatus({
        userId,
        docId: currentDocId,
        status: 'COMPLETED',
        category: currentTask,
        subCategory: null,
        candidateId: currentCandidateId,
      });
    }
  };

  return (
    <Fragment>
      {!isNil(currentCandidate) ? (
        <HireRejectConfirmationModal
          isOpen={isOpen}
          warningMessage={false}
          disabled={false}
          onClose={onClose}
          candidateFromProps={currentCandidate?.candidate}
          disableAllFields
          onSuccessCallback={updateToCompleted}
        />
      ) : null}
    </Fragment>
  );
};
